import {toArray} from "./helpers";

/**
 * This function is called in the script filtergroups.js
 * and checks if a standard (normen) download table has no results
 * in case of filtering and hides then the whole table section with headline
 * @param filterTarget
 */
export function checkStandardTableIsEmpty(filterTarget = '') {

  let elements = toArray(filterTarget)

  elements.forEach(element => {

    let tableIsEmpty = true;
    let tableRows = element.getElementsByTagName("tr");

    toArray(tableRows).forEach(element => {
      if(element.offsetParent !== null) {
        tableIsEmpty = false;
      }
    })

    if (tableIsEmpty) {
      element.classList.add("vishidden");
    } else {
      element.classList.remove("vishidden");
    }

  })
}
